<template id="page-top">
  <notifications position="top center" />
  <vue3-confirm-dialog></vue3-confirm-dialog>

  <ChatSupport v-if="showLayout" /> 

  <div id="app" class="d-flex flex-column min-vh-100">
    <menuTop v-if="showLayout"></menuTop>

    <div :class="showLayout ? 'container-fluid mt-4 main-content flex-grow-1' : 'flex-grow-1 d-flex flex-column'">
      <router-view />
      <LoadingOverlay :active="loading.active" :message="loading.message" />
    </div>
  </div>

  <MenuFooter v-if="showLayout"></MenuFooter>
</template>

<script>
import menuTop from '@/components/menu/menu-top.vue'
import ChatSupport from './components/chat/chat-support.vue'
import MenuFooter from './components/menu/menu-footer.vue';
import LoadingOverlay from '@/components/LoadingOverlay.vue'


export default {
  name: 'App',
  components: {
    menuTop,
    ChatSupport,
    MenuFooter,
    LoadingOverlay,
    
	},
  data() {
    return {
      loading: {
        active: false,
        message: 'Processando...'
      }
    }
  },

  provide() {
    return {
      globalLoading: {
        show: (msg = 'Processando...') => {
          this.loading.message = msg;
          this.loading.active = true;
        },
        hide: () => {
          this.loading.active = false;
        }
      }
    };
  },

  mounted() { },
  computed: {
    showLayout() {
      return this.$route.meta.requiresAuth === true;
    }
  }
}
</script>

<style></style>